import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core'
import { NgForm } from '@angular/forms'
import { DataTableDirective } from 'angular-datatables'
import { Subject, Subscription } from 'rxjs'
import { ViewValidation } from '../../../_helpers/ViewValidation'
import { ActivatedRoute } from '@angular/router'
import { NotificationService } from '../../../services/notification.service'
import { CompanyService } from '../../../services/company.service'
import { OperationServiceService } from '../../../services/operation.service.service'
import { Company } from '../../../models/Company'
import { UserAdmin } from 'src/app/models/UserAdmin'
import { ListOperationServiceHistory, OperationServiceDataToReport } from 'src/app/models/OperationService'
import { HttpClient } from '@angular/common/http'
import { PATH } from 'src/app/app.api'
import * as moment_ from 'moment'
import { getIdentifierName, getLengthTable, getLoggedUser, setLengthTable, setOperationsServiceForReport } from 'src/app/_helpers/LocalStorage'
import { MatDialog } from '@angular/material'
import { InsertDateComponent } from '../../modal/insert-date/insert-date.component'
import { DetailsFromClick } from 'src/app/models/DetailsFromClick'
import { MapView } from '../../map-view/map-view.component'
import { SearchTruncated, searchTruncatedOperationServiceHistory } from 'src/app/_helpers/SearchTruncated'
import { insertOrRemoveClassInScrollButton, removeToolTip, scrollToConteiner } from 'src/app/_helpers/Utils'
import { IItenPositionWithYourPage, getGeneralPositionOfItemSelected, recalculatePagePositionOfItensSelected } from 'src/app/_helpers/InteractionsWithTables'
import { TreeService } from 'src/app/services/tree.service'
import { ExportService } from '../../../services/export.service'
import { ColumnMapType, getTableConfiguration, setTableConfiguration, TablesPanel } from 'src/app/_helpers/Table-settings'

@Component({
	selector: 'app-operation-service-history',
	templateUrl: './operation-service-history.component.html'
})
export class OperationServiceHistoryComponent implements OnInit, AfterViewInit {
	@ViewChild('form') public form: NgForm
	@ViewChild(MapView) public mapView: MapView
	public currentPageTable: number = 0;

	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective
	@ViewChild('tableConteiner')
	public tableConteiner: ElementRef<HTMLDivElement>
	public refreshTable: Subject<any> = new Subject()
	public dataTableParams: any
	public datatableOptions: DataTables.Settings = {}
	public updateDataTable = value => this.filterSearchTree(value)

	public operations: Array<ListOperationServiceHistory>
	public numberOfOperations: number = 0
	public company: Company
	public ViewValidation: ViewValidation = new ViewValidation()
	public sessionUser: UserAdmin = getLoggedUser()
	public companyId: string = localStorage.getItem('companyId')
	public searchText: string = ''
	public identifierName = getIdentifierName()
	public dateStart: string = ''
	public dateEnd: string = ''
	public isAdmin: boolean = Boolean(this.sessionUser.roles.includes('GENERAL_ADMIN'))
	public hasPermitionToAccessProtectedRoutesReportArboreal: boolean = false

	public pinsForMap: Array<any>
	public questionStateInventoryManagement: any
	public operationServiceSelectedFromMapView: DetailsFromClick = new DetailsFromClick()
	public operationServiceHistoryMany: Array<string> = []
	public selectAllActive: boolean = true

	public operationServiceHistorySearchTruncated: Array<SearchTruncated> = searchTruncatedOperationServiceHistory
	public searchTruncatedStringFormated: string = ''
	public showScrollUpButton: boolean = false
	public lengthTable: string = getLengthTable()
	public showOnlySelected: boolean = false
	public generalPositionOfItensSelected: Array<IItenPositionWithYourPage> = []
	public pagesWithItensSelected: Array<number> = []
	public showPinMoveAlertModal: boolean = false
	public fragmentsSelected: Array<number> = [];
	public dataForReports: Array<OperationServiceDataToReport> = [];
	public showSetTable: boolean = false;
	public settingsTable: ColumnMapType = getTableConfiguration(TablesPanel.HISTORY_OPERATION);

	public httpListSubscription: Subscription

	constructor(
		public notificationService: NotificationService,
		private operationServiceService: OperationServiceService,
		private companyService: CompanyService,
		private treeService: TreeService,
		private activateRoute: ActivatedRoute,
		private http: HttpClient,
		public dialog: MatDialog,
		private readonly exportService: ExportService
	) { }

	public async ngOnInit(): Promise<void> {
		await this.getAllPinsFromMap()
		await this.getQuestionStateManagement()

		this.searchText =
			this.activateRoute.snapshot.queryParams.search ?
				this.activateRoute.snapshot.queryParams.search : ''

		this.fetchSessionUser()
		await this.setupDatatables()
		await this.fetchCompany()

		document.querySelector('main').className = ''
		this.rerender()

		const observer =
			new IntersectionObserver(([entry]) => {
				this.showScrollUpButton = entry.isIntersecting

				if (entry.isIntersecting) {
					insertOrRemoveClassInScrollButton()
				}
			})

		observer.observe(this.tableConteiner.nativeElement)
	}

	public fetchSessionUser(): void {
		this.hasPermitionToAccessProtectedRoutesReportArboreal = Boolean(
			this.sessionUser.assignments.includes('OPERATION_SERVICE_REPORT_READ') ||
			this.sessionUser.assignments.includes('OPERATION_SERVICE_REPORT_READ_ALL')
		)
	}

	public async fetchCompany(): Promise<void> {
		try {
			const response: Company = await this.companyService
				.detailCompany(this.companyId)
				.toPromise()
			this.company = response
		} catch (err) { }
	}

	private async setupDatatables(): Promise<void> {
		this.datatableOptions = {
			language: {
				processing: 'Processando...',
				lengthMenu: '_MENU_ resultados por página',
				info: 'Mostrando de _START_ até _END_ de _TOTAL_ registros',
				infoEmpty: 'Mostrando 0 até 0 de 0 registros',
				infoFiltered: '',
				infoPostFix: '',
				zeroRecords: '...',
				loadingRecords: 'Cargando...',
				emptyTable: 'Nenhum registro encontrado',
				paginate: {
					first: 'Primero',
					previous: 'Anterior',
					next: 'Próximo',
					last: 'Último'
				},
				aria: {
					sortAscending: ': Ordenar colunas de forma ascendente',
					sortDescending: ': Ordenar colunas de forma ascendente'
				}
			},
			pagingType: 'full_numbers',
			searching: true,
			ordering: true,
			info: true,
			autoWidth: false,
			pageLength: Number(this.lengthTable),
			lengthChange: false,
			columnDefs: [
				{
					targets: [5],
					type: 'date'
				},
				{
					targets: [5],
					type: 'date'
				}
			],
			order: [[5, 'desc']],
			orderMulti: true,
			serverSide: true,
			processing: true,

			ajax: (dataTablesParameters: any, callback) => {
				if (this.httpListSubscription) {
					this.httpListSubscription.unsubscribe()
				}
				this.httpListSubscription = this.http
					.get<any>(`${PATH}/operationservice/history?companyId=${this.companyId}&companyServiceProviderId=${this.sessionUser.companyServiceProviderId ? this.sessionUser.companyServiceProviderId : ''}&userId=${this.sessionUser._id}&skip=${dataTablesParameters.start}&limit=${dataTablesParameters.length}&orderBy=${dataTablesParameters.columns[dataTablesParameters.order[0].column].data}&orderByDirection=${dataTablesParameters.order[0].dir}&search=${this.searchText}&startDate=${this.dateStart}&endDate=${this.dateEnd}${this.searchTruncatedStringFormated && this.searchTruncatedStringFormated}${this.showOnlySelected ? '&onlySelected=true&itensSelected=' + this.operationServiceHistoryMany : ''}`)
					.subscribe(resp => {
						this.currentPageTable = Math.floor(dataTablesParameters.start / dataTablesParameters.length)
						this.operations = resp.content
						this.dataTableParams = dataTablesParameters
						callback({
							recordsFiltered: resp.numberOfPages,
							recordsTotal: resp.numberOfPages,
							data: []
						})
						this.numberOfOperations = resp.numberOfPages
						this.switchSelectAllButton(true)
					})
			},
			columns: [
				{ data: 'actions' , orderable: false},
				{ data: 'select', orderable: false },
				{ data: 'process' },
				{ data: 'identifier' },
				{ data: 'treeId' },
				{ data: 'data' },
				{ data: 'requester' },
				{ data: 'oso' },
				{ data: 'operator' },
				{ data: 'companyServiceProvider' },
				{ data: 'address' },
				{ data: 'region' },				
				{ data: 'riskCategory' },
				{ data: 'management' },
			]
		}
	}

	public async filterSearchTree(value: any): Promise<void> {
		const isData = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
		if (isData.test(value)) {
			this.dateStart = moment_(value, 'DD/MM/YYYY').format(
				'YYYY-MM-DD'
			)
			this.dateEnd = moment_(value, 'DD/MM/YYYY').add('days', 1).format(
				'YYYY-MM-DD'
			)
		} else {
			this.dateStart = ''
			this.dateEnd = ''
			this.searchText = value.toLowerCase() == 'muito alto' ? 'muito_alto' : value
		}
		this.clearSelections()
		this.rerender()
	}

	public rerender(): void {
		if (this.dtElement.dtInstance) {
			this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
				document.querySelector('table').classList.add('hide')
				dtInstance.destroy()
				this.refreshTable.next()
				setTimeout(() => {
					document.querySelector('table').classList.remove('hide')
				}, 500)
			})
		} else {
			this.refreshTable.next()
		}
	}

	public operationServiceHisOperator(operatorId: string): boolean {
		return Boolean(
			this.sessionUser.roles.includes('GENERAL_ADMIN') ||
			this.sessionUser.roles.includes('CUSTOMER') ||
			this.sessionUser.roles.includes('USER') ||
			(operatorId == this.sessionUser._id &&
				this.sessionUser.assignments.includes('OPERATION_SERVICE_REPORT_READ')) ||
			this.sessionUser.assignments.includes('OPERATION_SERVICE_REPORT_READ_ALL')
		)
	}

	public fragmentServiceHisOperator(operatorId: string): boolean {
		return Boolean(
			this.sessionUser.roles.includes('GENERAL_ADMIN') ||
			this.sessionUser.roles.includes('CUSTOMER') ||
			this.sessionUser.roles.includes('USER') ||
			(operatorId == this.sessionUser._id &&
				this.sessionUser.assignments.includes('OPERATION_SERVICE_REPORT_READ')) ||
			this.sessionUser.assignments.includes('OPERATION_SERVICE_REPORT_READ_ALL')
		)
	}

	public ngAfterViewInit(): void {
		this.refreshTable.next()
	}

	public async getAllPinsFromMap(): Promise<any> {
		this.pinsForMap = await this.operationServiceService.getOperationsHistory(this.companyId).toPromise()
	}

	public async getQuestionStateManagement(): Promise<void> {
		this.questionStateInventoryManagement = await this.operationServiceService.getQuestionStateTree(this.companyId).toPromise()
	}

	public async updateMapCache() {
		this.pinsForMap = await this.operationServiceService.updateMapCache(this.companyId, this.sessionUser.email).toPromise()
	}

	public async setOperationServiceSelectFromTable(idMongo: string) {

		const mapBody = document.getElementsByClassName('map-content')[0]

		mapBody.scrollIntoView({
			behavior: 'smooth'
		})

		const inventorySelected = await this.operationServiceService.getClickTree(idMongo, this.companyId).toPromise()

		inventorySelected.idMongo = idMongo

		this.operationServiceSelectedFromMapView = inventorySelected
	}

	public async updateLocationPin(data: any) {
		this.showPinMoveAlertModal = true

		await this.operationServiceService.updateLocationPinMapHistory(
			data.idMongo,
			data.location
		).toPromise()
	}

	public closeAlertModal() {
		this.showPinMoveAlertModal = false
	}


	/*******************************************************************
	 * Exportar Excel
	 *******************************************************************/
	public async exportAsXLSXOperationServices() {

		const dialogRef = this.dialog.open(InsertDateComponent)
		dialogRef.componentInstance.close = dialogRef.close
		let dateStart: number
		let dateEnd: number

		dialogRef.afterClosed().subscribe(async result => {
			if (!dialogRef.componentInstance.cancel) {
				let dateAux = dialogRef.componentInstance.dateStart.split('/')
				dateStart = new Date(Number(dateAux[2]), Number(dateAux[1]) - 1, Number(dateAux[0])).getTime()
				dateAux = dialogRef.componentInstance.dateEnd.split('/')
				dateEnd = new Date(Number(dateAux[2]), Number(dateAux[1]) - 1, Number(dateAux[0])).getTime()
			}
			if (!dateStart || !dateEnd) return

			if (this.isAdmin) {
				await this.operationServiceService.getExportOperationServicesHistory(this.companyId, dateStart, dateEnd).toPromise()
				this.notificationService.notify('Aguarde, estamos montando seu excel. O download iniciará em breve.', 200)
				return
			}

			const diffMonths = (dateEnd - dateStart) / (1000 * 60 * 60 * 24 * 30)

			if (diffMonths > 3 ) {
				this.notificationService.notify('O período de exportação excede o limite de três meses. Entre em contato com o administrador do sistema', 404)
				return
			}

			if (diffMonths > 1) {
				this.notificationService.notify('O período de exportação solicitado é de um mês ou mais, o arquivo será enviado para o seu email', 200)
				await this.exportService.sendExportByEmail({type: 'operation-historic', dateEnd, dateStart}).toPromise()
			} else {
				await this.operationServiceService.getExportOperationServicesHistory(this.companyId, dateStart, dateEnd).toPromise()
				this.notificationService.notify('Aguarde, estamos montando seu excel. O download iniciará em breve.', 200)
			}
		})
	}

	public selectedManysOperationHistory(operation: ListOperationServiceHistory) {
		const index = this.operationServiceHistoryMany.indexOf(operation.idMongo)

		if (index > -1) {
			this.operationServiceHistoryMany.splice(index, 1)
		} else {
			this.operationServiceHistoryMany.push(operation.idMongo)
		}

		this.interactWithMap()
		this.switchSelectAllButton()
	}

	public interactWithMap() {
		if (this.mapView) {
			this.mapView.changeViewPinsFromMap(true)
			this.mapView.enableOrDisableShowOnlySelectButton()
		}
	}

	public selectOrUnselectAllItens() {
		if (this.selectAllActive) {
			this.selectAllItensForList()
		} else {
			this.unselectAllItensForLIst()
		}
	}

	public selectAllItensForList() {
		this.operations.forEach((item, i) => {
			if (!this.operationServiceHistoryMany.includes(item.idMongo)) {
				this.operationServiceHistoryMany.push(item.idMongo)
			}

			const guardEnableReport: boolean = Boolean(
				item.enableSpecialReport ||
				(
					item.status == 'REALIZADO' &&
					!item.fragmented
				)
			);

			if (
				this.findIndexOperationSelectedToReport(item.idMongo) == -1 &&
				guardEnableReport
			) {
				this.dataForReports.push({
					idMongo: item.idMongo
				})
			}

			if (item.fragmented) {
				item.fragments.forEach(fragment => {
					if (
						this.findIndexOperationSelectedToReport(
							item.idMongo, 
							fragment.id
						) == -1
					) {
						this.dataForReports.push({
							idMongo: item.idMongo,
							fragmentId: fragment.id
						})
					}

					if (this.findIndexFragmentSelected(fragment.id) === -1) {
						this.fragmentsSelected.push(fragment.id);
					}
				})
			}

			this.setGeneralPositionItenSelected(i, true, false)
		})

		this.interactWithMap()
		this.selectAllActive = false
	}

	public unselectAllItensForLIst() {
		this.operations.forEach((item, i) => {
			const index = this.operationServiceHistoryMany.indexOf(item.idMongo)

			if (index != -1) {
				this.operationServiceHistoryMany.splice(index, 1)
			}

			if (
				this.findIndexOperationSelectedToReport(item.idMongo) !== -1
			) {
				this.dataForReports.splice(
					this.findIndexOperationSelectedToReport(item.idMongo),
					1
				)
			}

			if (item.fragmented) {
				item.fragments.forEach(fragment => {
					if (
						this.findIndexOperationSelectedToReport(
							item.idMongo, 
							fragment.id
						) !== -1
					) {
						this.dataForReports.splice(
							this.findIndexOperationSelectedToReport(
								item.idMongo, 
								fragment.id
							), 1
						)
					}

					if (this.findIndexFragmentSelected(fragment.id) !== -1) {
						this.fragmentsSelected.splice(
							this.findIndexFragmentSelected(fragment.id), 1
						);
					}
				})
			}
			
			this.setGeneralPositionItenSelected(i, false, true)
		})

		this.interactWithMap()
		this.selectAllActive = true
	}

	public switchSelectAllButton(active?: boolean) {

		const itensIds: Array<string> = []

		this.operations.forEach(item => {
			itensIds.push(item.idMongo)
		})

		const allItensSelected: boolean = itensIds.every(item => this.operationServiceHistoryMany.includes(item))
		const allItensUnSelected: boolean = itensIds.every(item => !this.operationServiceHistoryMany.includes(item))

		if (allItensSelected) {
			this.selectAllActive = false
			return
		} else if (allItensUnSelected) {
			this.selectAllActive = true
			return
		}

		if (active) {
			this.selectAllActive = active
		}
	}

	public searchTruncated(value: string) {
		this.searchTruncatedStringFormated = value
		this.clearSelections()
		this.rerender()
	}

	public openModalChoosePrint: boolean = false

	public openSelectionModeModal(operation?: ListOperationServiceHistory) {
		removeToolTip()

		if (operation) {
			this.operationServiceHistoryMany = [operation.idMongo];
			this.dataForReports = [{
				idMongo: operation.idMongo
			}]
		}
		this.openModalChoosePrint = !this.openModalChoosePrint
	}

	public openSelectionModeModalWithFragment(
		operationId: string,
		fragmentId: number
	) {
		removeToolTip()

		this.operationServiceHistoryMany = [];
		this.fragmentsSelected = [fragmentId];
		this.dataForReports = [{
			idMongo: operationId,
			fragmentId
		}]

		this.openModalChoosePrint = !this.openModalChoosePrint
	}

	public exportReport() {
		this.treeService.exportReport({
			type: 'operation-report-arboreal',
			ids: this.operationServiceHistoryMany,
			operationsData: this.dataForReports
		});

		this.openSelectionModeModal()
	}

	public runOperationServiceReportArboreal() {
		setOperationsServiceForReport(this.dataForReports);
		this.openSelectionModeModal();

		const url: string = '#/protected/operationReportArboreal';
		window.open(url, '_blank');
	}

	public updateLengthTable(newLength: string) {
		this.datatableOptions.pageLength = parseInt(newLength)
		this.rerender()
		setLengthTable(newLength)

		const newGeneralPositionItem = recalculatePagePositionOfItensSelected(
			Number(newLength),
			this.generalPositionOfItensSelected
		)
		this.generalPositionOfItensSelected = newGeneralPositionItem.allItensSelected
		this.pagesWithItensSelected = newGeneralPositionItem.allPagesSelected
	}

	public runToInitTable() {
		const table: HTMLDivElement =
			document.getElementsByClassName('datatables-content')[0] as HTMLDivElement

		scrollToConteiner(table)
		insertOrRemoveClassInScrollButton()
	}

	public viewOnlySelected() {
		this.showOnlySelected = !this.showOnlySelected

		this.rerender()
	}

	public setGeneralPositionItenSelected(
		indexInCurrentPage: number,
		selectingAll: boolean,
		unSelectingAll: boolean
	) {
		const generalPositionItem = getGeneralPositionOfItemSelected(
			indexInCurrentPage + 1,
			Number(this.lengthTable),
			this.generalPositionOfItensSelected,
			selectingAll,
			unSelectingAll,
			this.currentPageTable
		)
		this.generalPositionOfItensSelected = generalPositionItem.allItensSelected
		this.pagesWithItensSelected = generalPositionItem.allPagesSelected
	}

	public showFragments(operation: ListOperationServiceHistory) {
		operation.showFragments = !Boolean(operation.showFragments)
	}

	public clearSelections() {
		this.operationServiceHistoryMany = []
		this.generalPositionOfItensSelected = []
		this.pagesWithItensSelected = []
		this.dataForReports = [];
	}

	public openSetTable() {
		this.showSetTable = !this.showSetTable;
	}

	public setNewTableConfig(configColumns: ColumnMapType) {
		this.settingsTable = configColumns;
		setTableConfiguration(TablesPanel.HISTORY_OPERATION, configColumns);
		this.openSetTable();
	}
	
	public selectOperationToReport(operation: ListOperationServiceHistory) {
		const guardEnableReport: boolean = Boolean(
			operation.enableSpecialReport ||
			(
				operation.status == 'REALIZADO' &&
				!operation.fragmented
			)
		);

		if (!guardEnableReport) return;

		if (
			this.findIndexOperationSelectedToReport(operation.idMongo) == -1
		) {
			this.dataForReports.push({
				idMongo: operation.idMongo
			})
		} else {
			this.dataForReports.splice(
				this.findIndexOperationSelectedToReport(operation.idMongo),
				1
			)
		}
	}

	public selectOperationFragmentToReport(operationId: string, fragmentId: number) {
		if (
			this.findIndexOperationSelectedToReport(operationId, fragmentId) == -1
		) {
			this.dataForReports.push({
				idMongo: operationId,
				fragmentId
			})
		} else {
			this.dataForReports.splice(
				this.findIndexOperationSelectedToReport(operationId, fragmentId),
				1
			)
		}
		this.selectFragment(fragmentId);
	}

	public selectFragment(fragmentId: number) {		
		if (this.findIndexFragmentSelected(fragmentId) === -1) {
			this.fragmentsSelected.push(fragmentId);
		} else {
			this.fragmentsSelected.splice(
				this.findIndexFragmentSelected(fragmentId), 1
			);
		}
	}

	public findIndexOperationSelectedToReport(
		operationId: string,
		fragmentId?: number
	): number {
		return this.dataForReports.findIndex(operation => 
			operation.idMongo == operationId && 
			operation.fragmentId == fragmentId
		);
	}
	
	public findIndexFragmentSelected(fragmentId: number): number {
		return this.fragmentsSelected.findIndex(
			fragment => fragment == fragmentId
		);
	}
}
